const routes = [
    {
      path: "/contacts",
      name: "contacts",
      component: () => import("../components/settings/contact.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/actions",
      name: "actions",
      component: () => import("../components/settings/action.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/bannettes",
      name: "bannettes",
      component: () => import("../components/settings/Bannettes.vue"),
    },
    {
      path: "/variable_globale",
      name: "variable_globale",
      component: () => import("../components/settings/global_variable.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/jobs",
      name: "jobs",
      component: () => import("../components/settings/job.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/entities_trees",
      name: "entities_trees",
      component: () => import("../components/settings/entity/EntityTree.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/structures_trees",
      name: "structures_trees",
      component: () => import("../components/settings/structure/StructureTree.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/typologies_trees",
      name: "typologies_trees",
      component: () => import("../components/settings/typology/TypologyTree.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/user_actions",
      name: "user_actions",
      component: () => import("../components/settings/user_action.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: "/memo_models",
      name: "memo_models",
      component: () => import("../components/settings/memo/MemoModel.vue"),
      meta: {
          requiresAuth: true
      }
    },
];

export default routes;